import * as React from 'react';
import Spacing from '@able/react/dist/Spacing';
import InlineLink from '@able/react/dist/InlineLink';
import TextStyle from '@able/react/dist/TextStyle';
import '../../../../../order-details-new/style.less';

const ProgressTrackerTabFooter = () => {
  return (
    <React.Fragment>
      <section>
        <Spacing top="spacing3x" bottom="spacing3x" >
          <InlineLink className="product-details-sheet-footer-link">
            <TextStyle alias="TextBodyShort">
              <p>
                For help with your order, connect with your Telstra order contact
                or <a href="/app/customer-support/new-enquiry">submit an enquiry</a>.
              </p>
            </TextStyle>
          </InlineLink>
        </Spacing>
      </section>
    </React.Fragment>
  );
};

export default ProgressTrackerTabFooter;
